"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FoldersIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.31 2.243L3.5 3H12l-1.678-1.343A3 3 0 008.448 1H4.28a1 1 0 00-.97 1.243zM2.125 4.602L2.417 6h11.166l.292-1.398a.5.5 0 00-.49-.602H2.615a.5.5 0 00-.49.602zM0 7l.781 6.248A2 2 0 002.766 15h10.468a2 2 0 001.985-1.752L16 7H0z"
  })))
});
FoldersIcon.displayName = 'FoldersIcon';
var _default = exports.default = FoldersIcon;